module.exports = __webpack_public_path__ + "static/media/vip_service.799bc401.svg";